// The calendar link under a booking on the task.
//
// Once the panel says "Booked" staff want to see it on the calendar to be
// sure it is there. The picker already has "Open in calendar"; a booked task
// hides the picker, and so lost the link. Same destination, same way back:
// the day the appointment is on, that provider, and the dashboard reopening
// this task from ?taskId=.
export interface BookedForLink { date?: string | null; specialistId?: string | null; }

export interface CalendarLink {
  to: string;
  state: { returnTo: string; backLabel: string };
}

export function bookedCalendarLink(booked: BookedForLink, taskId: string): CalendarLink | null {
  const day = String(booked.date || '').slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(day)) return null;
  const params = new URLSearchParams({ date: day, view: 'day' });
  if (booked.specialistId) params.set('provider', String(booked.specialistId));
  return {
    to: `/calendar?${params.toString()}`,
    state: { returnTo: `/?taskId=${taskId}`, backLabel: 'Back to task' },
  };
}
